import React from 'react';
import cn from 'classnames';
import styles from './Alert.module.scss';

export function Alert(props) {
  const alertVisibleClass = props.visible ? styles.alertVisible : '';
  return (
    <div className={cn(styles.alert, alertVisibleClass)}>{props.text}</div>
  );
}

export default Alert;
